import React from 'react';
import PropTypes from 'prop-types';
import {Notebook} from '../Notebook';
import {Modal} from '@learningblocks/exp-components';
import {LevelSelector} from '@learningblocks/storybook-components';
import {ProtocolView} from '../ProtocolView';
import {Modal as SceneModal} from "../ProtocolScene/Dialogs/modal";

import {PageTour} from './PageTour';
import {
  TOUR_PROPERTIES
} from '@learningblocks/protocol-constants/lib/Utilities';


import BackgroundImage from "./img/Background.svg"

export class MainScene extends React.Component {

  handleJoyrideCallback = ({action, index, status, lifecycle}) => {
    if (
      action === TOUR_PROPERTIES.NEXT &&
      index === this.props.stepIndex &&
      lifecycle === TOUR_PROPERTIES.COMPLETE
    ) {
      this.props.incrementTour();
    } else if (status === TOUR_PROPERTIES.FINISH) {
      this.props.endTour();
    } else if (action === TOUR_PROPERTIES.CLOSE) {
      this.props.endTour();
    }
  };

  componentWillMount(){
    this.props.setLevel({
      id: 1,
      label: 'Level one',
      description: 'For those unfamiliar with the technique, offers the most support and hints.',
      value: 'levelOne',
    })
    this.props.setNoteBookSection('CONTEXT')
  }


  render() {
    return (
      <div style={{
        backgroundImage: `url(${BackgroundImage})`,
        width: "100vw",
        height: "100vh"
      }}>
        <Modal
          isOpen={this.props.showLevelModal}
          contentLabel='Select Simulation Level'
          className='Modal sm'
          size='sm'>
          <LevelSelector
            simulationLevels={[
              {
                id: 1,
                label: 'Level one',
                description: 'For those unfamiliar with the technique, offers the most support and hints.',
                value: 'levelOne',
              },
              // {
              //   id: 2,
              //   label: 'Level two',
              //   description: 'For users familiar with the technique, offers fewer procedural hints and less detailed explanations of the procedural steps.',
              //   value: 'levelTwo',
              // },
              // {
              //   id: 3,
              //   label: 'Level three',
              //   description: 'For ​those well acquainted with the technique, emphasizing ​exploration of ​new skills and topics.',
              //   value: 'levelThree',
              // },
            ]}
            defaultSelected={1}
            setLevel={(level)=>{
              this.props.setLevel(level)
              this.props.setNoteBookSection('CONTEXT')
            }}
          />
        </Modal>
        {this.props.levelSelected && (
          <>
          <Notebook />
          <ProtocolView />
          <SceneModal />
          <PageTour handleJoyrideCallback={this.handleJoyrideCallback} />
          </>
        )}
      </div>
    );
  }
}

MainScene.propTypes = {
  showLevelModal: PropTypes.bool.isRequired,
  setLevel: PropTypes.func.isRequired,
  /**
   *  function for ending tour
   */
  endTour: PropTypes.func,
  /**
   *  function to  incrementing stepIndex
   */
  incrementTour: PropTypes.func,
  /**
   *  index for Page tour
   */
  stepIndex: PropTypes.number,
};
